export default "__VITE_ASSET__DAqrlbeW__"